import {useContext} from "react";
import {SideNavContext} from "@lib/hooks/contexts/side-nav-context";

export const useSideNav = () => (
    useContext(SideNavContext)
)